import React, { useState } from 'react'
import { BarChartOutlined } from '@ant-design/icons'
import buttonStyle from '@sass/common/button.module.sass'
import style from './index.module.sass'
import { InfoBlockModalDashbaord } from './modal-dashboard'


type Props = {
	id: string
	name: string
}

export const MetabaseDashboardButton = (props: Props) => {
	const [showModal, setShowModal] = useState(false)
	return (
		<div className={style.container}>
			<div>
				<button className={buttonStyle.greySolid} onClick={() => setShowModal(true)}>
					<BarChartOutlined /> &nbsp;
					{props.name}
				</button>
			</div>
			{/* Note: We don't use a route here as this component is reachable from both
			the public form AND regular form (via different URLS) */}
			{showModal && <InfoBlockModalDashbaord id={props.id} name={props.name} setShowModal={setShowModal} />}
		</div>
	)
}
